import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { 
  Calendar, Clock, Users, MapPin, Car, Hotel, 
  ChevronDown, ChevronUp, Sparkles, Trophy,
  Music, Camera, Utensils, Wifi, Monitor, Award,
  Phone, Mail, CheckCircle2, ArrowRight, FileText, Download
} from 'lucide-react';

// Configure pdfMake fonts
if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
}

const BestDriveOfferPage = () => {
  const [expandedHotel, setExpandedHotel] = useState(null);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [selectedPartyItems, setSelectedPartyItems] = useState({
    kviz: true,
    dj: true,
    kasino: true,
    fotokoutek: true,
    dekorace: true,
    iluzionista_stage: true,
    iluzionista_hosty: true,
    leaders: true,
    zvuk: true
  });

  const toggleHotel = (hotelId) => {
    setExpandedHotel(expandedHotel === hotelId ? null : hotelId);
  };

  const selectHotel = (hotel) => {
    setSelectedHotel(hotel);
    // Scroll to pricing section after selection
    setTimeout(() => {
      const pricingSection = document.getElementById('pricing-section');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 300);
  };
  
  const togglePartyItem = (itemId) => {
    setSelectedPartyItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  // Export to PDF function
  const exportToPDF = () => {
    if (!selectedHotel) {
      alert('Prosím vyberte nejprve hotel');
      return;
    }

    const selectedItems = partyItems.filter(item => selectedPartyItems[item.id]);
    const grandTotal = selectedHotel.price + programTotal;

    const docDefinition = {
      content: [
        // Header
        { text: 'OBCHODNÍ NABÍDKA', style: 'header', alignment: 'center', margin: [0, 0, 0, 10] },
        { text: 'Výroční porada sítě BestDrive 2026', style: 'subheader', alignment: 'center', margin: [0, 0, 0, 30] },
        
        // Selected Hotel
        { text: 'VYBRANÁ VARIANTA HOTELU', style: 'sectionHeader', margin: [0, 20, 0, 10] },
        {
          table: {
            widths: ['*', 'auto'],
            body: [
              [{ text: 'Hotel', bold: true }, { text: selectedHotel.name, alignment: 'right' }],
              [{ text: 'Lokace', bold: true }, { text: selectedHotel.location, alignment: 'right' }],
              ['Ubytování', { text: selectedHotel.priceBreakdown.ubytovani.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }],
              ['Pronájem prostorů', { text: selectedHotel.priceBreakdown.pronajem.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }],
              ['Strava', { text: selectedHotel.priceBreakdown.strava.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }],
              ...(selectedHotel.priceBreakdown.technika ? [['Technické vybavení', { text: selectedHotel.priceBreakdown.technika.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedHotel.priceBreakdown.prestavba ? [['Přestavba sálu', { text: selectedHotel.priceBreakdown.prestavba.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedHotel.priceBreakdown.parking ? [['Parkování', { text: selectedHotel.priceBreakdown.parking.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedHotel.priceBreakdown.ostatni ? [['Ostatní', { text: selectedHotel.priceBreakdown.ostatni.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              [{ text: 'CELKEM HOTEL', bold: true, fillColor: '#f0f0f0' }, { text: selectedHotel.price.toLocaleString('cs-CZ') + ' Kč', bold: true, alignment: 'right', fillColor: '#f0f0f0' }]
            ]
          },
          margin: [0, 0, 0, 20]
        },
        
        // Program Costs
        { text: 'SPOLEČNÉ NÁKLADY PROGRAMU', style: 'sectionHeader', margin: [0, 20, 0, 10] },
        { text: 'Večerní část (vybrané položky):', bold: true, margin: [0, 0, 0, 5] },
        {
          ul: selectedItems.map(item => `${item.name}: ${item.price.toLocaleString('cs-CZ')} Kč`),
          margin: [0, 0, 0, 10]
        },
        {
          table: {
            widths: ['*', 'auto'],
            body: [
              ['Celkem večerní část', { text: programCosts.vecerniParty.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }],
              ['Agenturní provize', { text: programCosts.agenturniProvize.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }],
              ['Produkce a koordinace', { text: programCosts.produkce.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }],
              [{ text: 'CELKEM PROGRAM', bold: true, fillColor: '#f0f0f0' }, { text: programTotal.toLocaleString('cs-CZ') + ' Kč', bold: true, alignment: 'right', fillColor: '#f0f0f0' }]
            ]
          },
          margin: [0, 0, 0, 30]
        },
        
        // Grand Total
        {
          table: {
            widths: ['*', 'auto'],
            body: [
              [
                { text: 'CELKOVÁ INVESTICE', fontSize: 16, bold: true, fillColor: '#FDB913', color: '#000000' },
                { text: grandTotal.toLocaleString('cs-CZ') + ' Kč bez DPH', fontSize: 16, bold: true, alignment: 'right', fillColor: '#FDB913', color: '#000000' }
              ]
            ]
          },
          margin: [0, 0, 0, 20]
        },
        
        // Footer
        { text: 'Podmínky:', bold: true, margin: [0, 20, 0, 5] },
        {
          ul: [
            'Maximální rozpočet: 950 000 Kč bez DPH',
            'Fakturace: 90 % CZ / 10 % SK',
            'Uvedené ceny jsou bez DPH',
            'Večerní program lze flexibilně upravit dle rozpočtu'
          ],
          fontSize: 9
        },
        
        { text: '\n\nKontakt: info@vseproakci.cz | +420 773 550 880 | Ondruchová Monika', alignment: 'center', fontSize: 9, color: '#666666', margin: [0, 30, 0, 0] }
      ],
      styles: {
        header: {
          fontSize: 22,
          bold: true,
          color: '#FDB913'
        },
        subheader: {
          fontSize: 16,
          color: '#666666'
        },
        sectionHeader: {
          fontSize: 14,
          bold: true,
          color: '#FDB913'
        }
      },
      defaultStyle: {
        fontSize: 10
      }
    };

    pdfMake.createPdf(docDefinition).download(`BestDrive_Nabidka_${selectedHotel.name.replace(/\s+/g, '_')}.pdf`);
  };

  // Hotel data
  const hotels = [
    {
      id: 1,
      name: 'Orea Congress Hotel Brno',
      location: 'Brno, Křížkovského 458/47',
      image: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/jazfrqa6_orea%20congress%20hotel%20brno.jpg',
      shortDesc: 'Moderní 4* kongresový hotel v centru Brna s LED stěnou a kompletním AV zázemím',
      price: 572790,
      priceBreakdown: {
        ubytovani: 183800,
        pronajem: 103000,
        strava: 342300,
        prestavba: 9000,
        parking: 17000
      },
      roomDetails: {
        single: { count: 20, pricePerNight: 2170 },
        double: { count: 60, pricePerNight: 2340 }
      },
      spaces: [
        { name: 'Konferenční sál C', capacity: '350 osob (divadelní) / 200 osob (školní)', area: '302 m²', price: 33000 },
        { name: 'Konferenční sál D', capacity: '150 osob (divadelní) / 120 osob (školní)', area: '240 m²', price: 21000 },
        { name: 'Salónky (4×)', capacity: '60 osob (divadelní) / 36 osob (školní)', area: '80-83 m²', price: 40000 }
      ],
      advantages: [
        'Nejpříznivější cenová varianta (572 790 Kč)',
        'LED stěna 10×3m v ceně (varianta standard)',
        'Kapacita hlavního sálu C: 350 osob',
        'Breakout prostory: 4 salónky + sál D',
        'Parking: 65 míst (300-400 Kč/auto/den)',
        'Dostupnost: centrum Brna, 2h Praha, 1h Slovensko'
      ],
      availableDates: ['20.–21. ledna 2027'],
      why: 'Nejlevnější varianta s nejlepším poměrem cena/výkon. Profesionální kongresové prostory s moderní LED stěnou a multifunkčním foyer. Výborná dopravní dostupnost z ČR i SK.',
      contact: {
        person: 'Anna Čejková',
        role: 'Senior Sales Manager – Event Booking Center',
        phone: '+420 778 438 140',
        email: 'anna.cejkova@orea.cz'
      }
    },
    {
      id: 2,
      name: 'NH Collection Olomouc Congress',
      location: 'Olomouc, Legionářská 1311/21',
      image: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/zfy32tc1_NH%20olomouc.jpg',
      shortDesc: 'Prémiový kongresový hotel s nejmodernější AV technikou a LED rámovým plátnem',
      price: 937500,
      priceBreakdown: {
        ubytovani: 241071,
        pronajem: 142975,
        strava: 407500,
        technika: 145954
      },
      roomDetails: {
        single: { count: 20, pricePerNight: 3000 },
        double: { count: 60, pricePerNight: 3500 }
      },
      spaces: [
        { name: 'Evropa 1 (hlavní sál)', capacity: '140 osob', area: '-', price: 75000 },
        { name: 'Restaurace Ventana (večerní program)', capacity: '140 osob', area: '-', price: 20000 },
        { name: 'Evropa 2+3', capacity: '140 osob', area: '-', price: 30000 },
        { name: 'Salónky (Madrid, Olomouc) - 6× dní', capacity: '30 osob', area: '-', price: 78000 }
      ],
      technical: [
        { item: 'Rámové plátno 15,5×3m + projektory', price: 29000 },
        { item: 'Pódium profesionální MILOS (2×)', price: 116004 },
        { item: 'Bezdrátový mikrofon', price: 1600 },
        { item: 'Laserové projektory full HD-4K (6×)', price: 30000 }
      ],
      advantages: [
        'Rámové LED plátno 15,5×3m (největší v regionu)',
        'Kapacita hlavního sálu Evropa 1: 140 osob',
        'Breakout prostory: 6× salónky po 30 osob',
        'Parking: 100 míst (300 Kč/auto/den)',
        'Profesionální MILOS pódia a full HD projektory'
      ],
      availableDates: ['19.–20. ledna 2027', '26.–28. ledna 2027'],
      why: 'Nejvyšší standard pro náročné korporátní akce. Kompletní technické zázemí včetně nejmodernější AV techniky (LED plátno 15,5m, 4K projektory). Ideální pro velké produkce.',
      contact: {
        person: 'Veronika Janíček Balážová',
        role: 'Sales Manager',
        phone: '+420 734 236 060',
        email: 'v.janicekbalazova@nh-hotels.com'
      },
      pdfUrl: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/2kfjrk4u_270100%20eventtime.pdf',
      brochureUrl: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/lsetybi5_NH%20Collection%20Olomouc%20broz%CC%8Cura_2026.pdf'
    },
    {
      id: 3,
      name: 'Clarion Congress Hotel Brno',
      location: 'Brno, Křížkovského 20',
      image: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/6rzx7t9r_Sni%CC%81mek%20obrazovky%202026-03-24%20v%C2%A022.13.00.png',
      shortDesc: 'Největší kongresové centrum jižní Moravy s flexibilními prostory',
      price: 785390,
      priceBreakdown: {
        ubytovani: 218750,
        pronajem: 66116,
        strava: 468707,
        technika: 31818
      },
      roomDetails: {
        single: { count: 20, pricePerNight: 2800 },
        double: { count: 60, pricePerNight: 3150 }
      },
      spaces: [
        { name: 'Velký kongresový sál MORAVIA I', capacity: '140 osob (školní uspořádání)', area: '-', price: 40000 },
        { name: 'Salónky (Petrov I, II, Špilas, Metropol I, II)', capacity: '30 osob (divadelní)', area: '-', price: 40000 }
      ],
      technical: [
        { item: 'Projektor s plátnem, ozvučení, 2× mikrofon', price: 15000 },
        { item: 'Technická obsluha ve velkém sále', price: 3500 },
        { item: 'LCD obrazovky (5×)', price: 20000 }
      ],
      food: [
        { item: 'Oběd formou bufetu (2× dny)', price: 95200 },
        { item: 'Coffee break (2× dny)', price: 49000 },
        { item: 'Večerní raut Clarion', price: 128800 },
        { item: 'Nápoje (welcome drink + obědy + raut)', price: 91000 }
      ],
      advantages: [
        'Největší kongresové centrum jižní Moravy',
        'Kapacita hlavního sálu MORAVIA I: 140 osob',
        'Breakout prostory: 5 salónků po 30 osob',
        'Parking: dostupný (590 Kč/noc)',
        'Service charge 5% zahrnut v ceně'
      ],
      availableDates: ['27.–28. ledna 2027'],
      why: 'Maximum flexibility. Dostatečné kapacity pro růst a různé formáty breakout sessionů. Kompletní cenová kalkulace zahrnuje i service charge a technickou obsluhu.',
      contact: {
        person: 'Event Sales Team',
        role: 'Congress Sales',
        phone: '+420 533 338 111',
        email: 'congress@clarionbrno.cz'
      },
      pdfUrl: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/edli1crl_EVENT-TIME_2027_VES-1.pdf',
      factSheetUrl: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/cbc7rlso_CZE_fact_sheet_Clarion%20Congress%20Hotel%20Brno.pdf',
      visualizationUrl: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/61puzr7m_Clarion%20Congress%20Hotel%20Brno%20-%20vizualizace.pdf'
    },
    {
      id: 4,
      name: 'Central Park Flora s.r.o.',
      location: 'Olomouc, Wolkerova 34',
      image: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/7ot9ikqp_central%20park%20olomouc.jpg',
      shortDesc: 'Moderní hotel s wellness a nápojovým balíčkem NO LIMIT',
      price: 657230,
      priceBreakdown: {
        ubytovani: 171429,
        pronajem: 48099,
        strava: 414917,
        technika: 11653,
        ostatni: 11132
      },
      roomDetails: {
        single: { count: 20, pricePerNight: 2100 },
        double: { count: 60, pricePerNight: 2500 }
      },
      spaces: [
        { name: 'NARCIS + IRIS (1. den)', capacity: '140 osob (školní)', area: '-', price: 40000 },
        { name: 'Salónky (5×) - IRIS, TULIPÁN, FOREST, STRELICIE, SLUNEČNICE', capacity: '30 osob (divadelní)', area: '-', price: 18200 }
      ],
      advantages: [
        'Nápojový balíček NO LIMIT po celé 2 dny',
        'Příznivá cenová varianta (657 230 Kč)',
        'Kapacita hlavního sálu: 140 osob',
        'Breakout prostory: 5 salónků po 30 osob',
        'Parking: 50 míst (100 Kč/noc)'
      ],
      availableDates: ['2.–3. února 2027', '3.–4. února 2027'],
      why: 'Dobrý poměr cena/výkon s bonusovým nápojovým balíčkem NO LIMIT. Wellness zázemí jako bonus pro večerní relax účastníků. Vhodné pro akce s vyššími nároky na nápoje.',
      contact: {
        person: 'Event Team',
        role: 'Congress Sales',
        phone: '+420 585 000 000',
        email: 'events@centralparkflora.cz'
      }
    }
  ];

  // Party items (evening program) - detailed breakdown
  const partyItems = [
    { id: 'kviz', name: 'Chytrý kvíz', price: 35000 },
    { id: 'dj', name: 'DJ a moderátor', price: 12000 },
    { id: 'kasino', name: 'Mobilní kasino', price: 19000 },
    { id: 'fotokoutek', name: 'Fotokoutek', price: 15000 },
    { id: 'dekorace', name: 'Dekorace prostor, ubrusy, kytky, svíčky', price: 10000 },
    { id: 'iluzionista_stage', name: 'Iluzionista stage show', price: 6000 },
    { id: 'iluzionista_hosty', name: 'Iluzionista mezi hosty 90min', price: 18000 },
    { id: 'leaders', name: 'Party leaders', price: 35000 },
    { id: 'zvuk', name: 'Zvuk', price: 10000 }
  ];

  // Calculate dynamic evening party total
  const vecerniPartyTotal = partyItems.reduce((sum, item) => 
    sum + (selectedPartyItems[item.id] ? item.price : 0), 0
  );

  // Program costs (dynamic calculation)
  const programCosts = {
    vecerniParty: vecerniPartyTotal,
    agenturniProvize: 100000,
    produkce: 30000
  };

  const programTotal = programCosts.vecerniParty + programCosts.agenturniProvize + programCosts.produkce;

  return (
    <div className="min-h-screen bg-[#050505] text-white font-['IBM_Plex_Sans']">
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Concept Section */}
      <ConceptSection />
      
      {/* Key Parameters */}
      <ParametersSection />
      
      {/* Hotel Selection (Accordion) */}
      <HotelSelectionSection 
        hotels={hotels} 
        expandedHotel={expandedHotel} 
        toggleHotel={toggleHotel}
        selectedHotel={selectedHotel}
        selectHotel={selectHotel}
        programTotal={programTotal}
      />
      
      {/* Timeline / Harmonogram */}
      <TimelineSection />
      
      {/* Smart Quiz Concept */}
      <QuizSection />
      
      {/* Evening Party Concept */}
      <PartySection />
      
      {/* Technical Support */}
      <TechnicalSection />
      
      {/* Pricing Calculation */}
      <PricingSection 
        programCosts={programCosts} 
        programTotal={programTotal} 
        selectedHotel={selectedHotel}
        partyItems={partyItems}
        selectedPartyItems={selectedPartyItems}
        togglePartyItem={togglePartyItem}
        exportToPDF={exportToPDF}
      />
      
      {/* CTA Section */}
      <CTASection />
      
    </div>
  );
};

// Hero Section
const HeroSection = () => (
  <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
    <div className="absolute inset-0 z-0">
      <img 
        src="https://images.unsplash.com/photo-1763805508094-901f2a79ff77?w=1920&q=85"
        alt="Automotive background"
        className="w-full h-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black" />
    </div>

    <div className="relative z-20 max-w-7xl mx-auto px-6 py-24 text-center">
      {/* BestDrive Logo */}
      <div className="mb-12 flex justify-center">
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl px-10 py-8 border border-white/10">
          <img 
            src="https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/uigm470y_Best%20Drive%20logo.jpg"
            alt="BestDrive by Continental"
            className="h-20 md:h-24 w-auto"
          />
        </div>
      </div>

      {/* Title */}
      <div className="mb-16">
        <h1 className="font-['Exo_2'] text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6 leading-tight">
          Výroční porada sítě<br />
          <span className="text-[#FDB913]">BestDrive 2026</span>
        </h1>
        <p className="text-2xl md:text-3xl text-zinc-400 font-light tracking-tight">
          Komplexní návrh řešení
        </p>
      </div>

      {/* Key Message */}
      <div className="max-w-3xl mx-auto">
        <div className="bg-zinc-900/60 backdrop-blur-xl border border-zinc-800 rounded-xl p-8">
          <p className="text-lg text-zinc-300 leading-relaxed">
            Efektivní pracovní setkání kombinované se silným networkingem. 
            Důraz na výkon, strukturu a zážitek, který posiluje týmovou spolupráci 
            napříč celou sítí BestDrive.
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-8 h-8 text-[#FDB913]" />
      </div>
    </div>
  </section>
);

// Concept Section
const ConceptSection = () => (
  <section className="py-24 px-6 bg-[#050505]">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-3 bg-[#FDB913] text-black px-6 py-3 rounded-full mb-6 font-bold">
          <Car className="w-5 h-5" />
          <span className="tracking-tight">KONCEPT AKCE</span>
        </div>
        <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-6">
          Drive Forward 2026
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8 hover:border-[#FDB913] transition-colors">
          <div className="w-12 h-12 bg-[#FDB913]/10 rounded-lg flex items-center justify-center mb-4">
            <Trophy className="w-6 h-6 text-[#FDB913]" />
          </div>
          <h3 className="text-xl font-bold mb-3">Strategie & Výkon</h3>
          <p className="text-zinc-400 leading-relaxed">
            Propojení strategických cílů s konkrétními výsledky a výkonovými metrikami.
          </p>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8 hover:border-[#FDB913] transition-colors">
          <div className="w-12 h-12 bg-[#FDB913]/10 rounded-lg flex items-center justify-center mb-4">
            <Users className="w-6 h-6 text-[#FDB913]" />
          </div>
          <h3 className="text-xl font-bold mb-3">Týmová Spolupráce</h3>
          <p className="text-zinc-400 leading-relaxed">
            Silný networking napříč celou sítí. Výměna zkušeností a best practices.
          </p>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8 hover:border-[#FDB913] transition-colors">
          <div className="w-12 h-12 bg-[#FDB913]/10 rounded-lg flex items-center justify-center mb-4">
            <CheckCircle2 className="w-6 h-6 text-[#FDB913]" />
          </div>
          <h3 className="text-xl font-bold mb-3">Efektivní Struktura</h3>
          <p className="text-zinc-400 leading-relaxed">
            Jasná struktura dne s optimálním využitím času účastníků. Bez zbytečností.
          </p>
        </div>
      </div>
    </div>
  </section>
);

// Parameters Section (Bento Grid)
const ParametersSection = () => (
  <section className="py-24 px-6 bg-[#121212]">
    <div className="max-w-6xl mx-auto">
      <h2 className="font-['Exo_2'] text-3xl md:text-4xl font-bold tracking-tight mb-12 text-center">
        Klíčové parametry akce
      </h2>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <Users className="w-8 h-8 text-[#FDB913] mb-3" />
          <div className="text-3xl font-bold mb-1">140</div>
          <div className="text-sm text-zinc-400">Účastníků</div>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <Hotel className="w-8 h-8 text-[#FDB913] mb-3" />
          <div className="text-3xl font-bold mb-1">1/2</div>
          <div className="text-sm text-zinc-400">Noc / Dny</div>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <Calendar className="w-8 h-8 text-[#FDB913] mb-3" />
          <div className="text-xl font-bold mb-1">Leden</div>
          <div className="text-sm text-zinc-400">Út–St / St–Čt</div>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <Car className="w-8 h-8 text-[#FDB913] mb-3" />
          <div className="text-3xl font-bold mb-1">~50</div>
          <div className="text-sm text-zinc-400">Parkovacích míst</div>
        </div>

        <div className="col-span-2 bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <Users className="w-8 h-8 text-[#FDB913] mb-3" />
          <div className="text-2xl font-bold mb-1">20× Single + Twin</div>
          <div className="text-sm text-zinc-400">Typ pokojů</div>
        </div>

        <div className="col-span-2 bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <MapPin className="w-8 h-8 text-[#FDB913] mb-3" />
          <div className="text-2xl font-bold mb-1">CZ + SK</div>
          <div className="text-sm text-zinc-400">Dostupnost</div>
        </div>
      </div>

      <div className="mt-8 text-center">
        <p className="text-zinc-500 text-sm">Demografie: 90 % muži, věk 40–50 let</p>
      </div>
    </div>
  </section>
);

// Hotel Selection (Accordion)
const HotelSelectionSection = ({ hotels, expandedHotel, toggleHotel, selectedHotel, selectHotel, programTotal }) => (
  <section className="py-24 px-6 bg-[#050505]">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-16">
        <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-4">
          Vyberte variantu řešení
        </h2>
        <p className="text-zinc-400 text-lg">4 prémiové hotely s komplexním kongresovým zázemím</p>
      </div>

      <div className="space-y-4">
        {hotels.map((hotel) => (
          <HotelCard 
            key={hotel.id} 
            hotel={hotel} 
            isExpanded={expandedHotel === hotel.id}
            isSelected={selectedHotel?.id === hotel.id}
            onToggle={() => toggleHotel(hotel.id)}
            onSelect={() => selectHotel(hotel)}
            programTotal={programTotal}
          />
        ))}
      </div>
    </div>
  </section>
);

// Individual Hotel Card (Accordion Item)
const HotelCard = ({ hotel, isExpanded, isSelected, onToggle, onSelect, programTotal }) => {
  const hotelPrice = hotel.price;
  
  return (
    <div 
      className={`bg-zinc-900 border-2 rounded-xl overflow-hidden transition-all ${
        isSelected 
          ? 'border-[#FDB913] shadow-lg shadow-[#FDB913]/20' 
          : 'border-zinc-800 hover:border-[#FDB913]/50'
      }`}
      data-testid={`hotel-card-${hotel.id}`}
    >
      {/* Collapsed Header */}
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-6 text-left hover:bg-zinc-800 transition-colors"
        data-testid={`hotel-toggle-${hotel.id}`}
      >
        <div className="flex items-center gap-6 flex-1">
          <div className="w-24 h-16 rounded-lg overflow-hidden flex-shrink-0">
            <img src={hotel.image} alt={hotel.name} className="w-full h-full object-cover" />
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-1">
              <h3 className="font-['Exo_2'] text-2xl font-bold">{hotel.name}</h3>
              {isSelected && (
                <span className="bg-[#FDB913] text-black text-xs font-bold px-3 py-1 rounded-full">
                  VYBRÁNA
                </span>
              )}
            </div>
            <p className="text-zinc-400 text-sm">{hotel.location} • {hotel.shortDesc}</p>
          </div>
          <div className="text-right mr-4">
            <div className="text-[#FDB913] text-3xl font-bold">{hotelPrice.toLocaleString('cs-CZ')} Kč</div>
            <div className="text-zinc-500 text-sm">hotel bez DPH</div>
          </div>
        </div>
        <div className="ml-4">
          {isExpanded ? (
            <ChevronUp className="w-6 h-6 text-[#FDB913]" />
          ) : (
            <ChevronDown className="w-6 h-6 text-zinc-400" />
          )}
        </div>
      </button>

      {/* Expanded Content */}
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="overflow-hidden"
          >
            <div className="border-t border-zinc-800 p-8 bg-zinc-950">
              <div className="grid md:grid-cols-2 gap-8 mb-8">
                {/* Left: Image */}
                <div className="rounded-xl overflow-hidden">
                  <img 
                    src={hotel.image} 
                    alt={hotel.name} 
                    className="w-full h-64 object-cover"
                  />
                </div>

                {/* Right: Details */}
                <div>
                  {/* Available Dates - only for hotels with this data */}
                  {hotel.availableDates && (
                    <div className="bg-[#FDB913]/10 border border-[#FDB913]/30 rounded-lg p-4 mb-6">
                      <div className="flex items-center gap-2 mb-3">
                        <Calendar className="w-5 h-5 text-[#FDB913]" />
                        <h4 className="text-sm font-bold text-[#FDB913]">Možné termíny konání</h4>
                      </div>
                      <div className="space-y-2">
                        {hotel.availableDates.map((date, idx) => (
                          <div key={idx} className="flex items-center gap-2 text-white">
                            <div className="w-2 h-2 bg-[#FDB913] rounded-full"></div>
                            <span className="font-semibold">{date}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  <h4 className="text-xl font-bold mb-4 text-[#FDB913]">Výhody</h4>
                  <ul className="space-y-2 mb-6">
                    {hotel.advantages.map((adv, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-zinc-300">
                        <CheckCircle2 className="w-5 h-5 text-[#FDB913] flex-shrink-0 mt-0.5" />
                        <span>{adv}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-4 mb-6">
                    <h5 className="text-sm font-bold text-zinc-400 mb-2">Proč zvolit tuto variantu?</h5>
                    <p className="text-zinc-300 text-sm leading-relaxed">{hotel.why}</p>
                  </div>

                  {/* Price Breakdown */}
                  <div className="bg-black/40 border border-zinc-800 rounded-lg p-4">
                    <h5 className="text-sm font-bold mb-3">Rozpis nákladů hotelu</h5>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span className="text-zinc-400">Ubytování (20× single + 60× twin)</span>
                        <span className="font-semibold">{hotel.priceBreakdown.ubytovani.toLocaleString('cs-CZ')} Kč</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-zinc-400">Pronájem prostorů (sály + salónky)</span>
                        <span className="font-semibold">{hotel.priceBreakdown.pronajem.toLocaleString('cs-CZ')} Kč</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-zinc-400">Strava (2× oběd, 3× coffee, večeře)</span>
                        <span className="font-semibold">{hotel.priceBreakdown.strava.toLocaleString('cs-CZ')} Kč</span>
                      </div>
                      {hotel.priceBreakdown.technika && (
                        <div className="flex justify-between">
                          <span className="text-zinc-400">Technické vybavení AV</span>
                          <span className="font-semibold">{hotel.priceBreakdown.technika.toLocaleString('cs-CZ')} Kč</span>
                        </div>
                      )}
                      {hotel.priceBreakdown.prestavba && (
                        <div className="flex justify-between">
                          <span className="text-zinc-400">Přestavba sálu</span>
                          <span className="font-semibold">{hotel.priceBreakdown.prestavba.toLocaleString('cs-CZ')} Kč</span>
                        </div>
                      )}
                      {hotel.priceBreakdown.parking && (
                        <div className="flex justify-between">
                          <span className="text-zinc-400">Parkování (50 vozidel)</span>
                          <span className="font-semibold">{hotel.priceBreakdown.parking.toLocaleString('cs-CZ')} Kč</span>
                        </div>
                      )}
                      <div className="border-t border-zinc-800 pt-2 mt-2 flex justify-between font-bold">
                        <span>Celkem hotel</span>
                        <span className="text-[#FDB913]">{hotel.price.toLocaleString('cs-CZ')} Kč</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="pt-6 border-t border-zinc-800 space-y-3">
                {/* Resource Links */}
                {hotel.id === 1 && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <a
                      href="https://congres-hotel-brno-orea.panopro.cz/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="py-3 rounded-lg font-semibold text-base transition-all flex items-center justify-center gap-2 bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700"
                      data-testid="hotel-3d-tour"
                    >
                      <Monitor className="w-5 h-5" />
                      3D Virtuální prohlídka
                    </a>
                    
                    <a
                      href="https://cdn.proposales.com/00afc369-6a83-45aa-af5f-b4eac4a8f820/-/inline/yes/OREA%20Congress%20Hotel%20Brno%20-%20Banketov%C3%A1%20nab%C3%ADdka%202026.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="py-3 rounded-lg font-semibold text-base transition-all flex items-center justify-center gap-2 bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700"
                      data-testid="hotel-pdf-catalog"
                    >
                      <FileText className="w-5 h-5" />
                      Kompletní informace o hotelu PDF
                    </a>
                  </div>
                )}
                
                {hotel.id === 2 && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <a
                      href={hotel.pdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="py-3 rounded-lg font-semibold text-base transition-all flex items-center justify-center gap-2 bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700"
                      data-testid="hotel-pdf-offer"
                    >
                      <FileText className="w-5 h-5" />
                      Podrobná cenová nabídka PDF
                    </a>
                    
                    <a
                      href={hotel.brochureUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="py-3 rounded-lg font-semibold text-base transition-all flex items-center justify-center gap-2 bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700"
                      data-testid="hotel-pdf-brochure"
                    >
                      <FileText className="w-5 h-5" />
                      Brožura hotelu PDF
                    </a>
                  </div>
                )}
                
                {hotel.id === 3 && hotel.pdfUrl && (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <a
                      href={hotel.pdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="py-3 rounded-lg font-semibold text-base transition-all flex items-center justify-center gap-2 bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700"
                      data-testid="hotel-pdf-offer"
                    >
                      <FileText className="w-5 h-5" />
                      Cenová nabídka PDF
                    </a>
                    
                    <a
                      href={hotel.factSheetUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="py-3 rounded-lg font-semibold text-base transition-all flex items-center justify-center gap-2 bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700"
                      data-testid="hotel-pdf-factsheet"
                    >
                      <FileText className="w-5 h-5" />
                      Fact Sheet PDF
                    </a>
                    
                    <a
                      href={hotel.visualizationUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="py-3 rounded-lg font-semibold text-base transition-all flex items-center justify-center gap-2 bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700"
                      data-testid="hotel-pdf-visualization"
                    >
                      <FileText className="w-5 h-5" />
                      Vizualizace PDF
                    </a>
                  </div>
                )}
                
                {hotel.id === 4 && (
                  <a
                    href="https://www.hotelflora.cz/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="py-3 rounded-lg font-semibold text-base transition-all flex items-center justify-center gap-2 bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700"
                    data-testid="hotel-website"
                  >
                    <Monitor className="w-5 h-5" />
                    Prezentace hotelu
                  </a>
                )}
                
                {/* Select Button */}
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect();
                  }}
                  className={`w-full py-4 rounded-lg font-bold text-lg transition-all flex items-center justify-center gap-3 ${
                    isSelected
                      ? 'bg-[#FDB913] text-black hover:bg-[#FDB913]/90'
                      : 'bg-zinc-800 text-white hover:bg-[#FDB913] hover:text-black border border-zinc-700'
                  }`}
                  data-testid={`hotel-select-${hotel.id}`}
                >
                  {isSelected ? (
                    <>
                      <CheckCircle2 className="w-5 h-5" />
                      Varianta vybrána
                    </>
                  ) : (
                    <>
                      <CheckCircle2 className="w-5 h-5" />
                      Vybrat tuto variantu
                    </>
                  )}
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

// Timeline Section
const TimelineSection = () => {
  const timeline = {
    day1: [
      { time: '10:00–11:30', title: 'Zahájení akce', type: 'main' },
      { time: '11:00–16:30', title: 'Přednáškové bloky BestDrive', type: 'main' },
      { time: '11:30–12:30', title: 'Oběd', type: 'break' },
      { time: '14:10–14:30', title: 'Coffee break I', type: 'break' },
      { time: '16:30–17:00', title: 'Coffee break II', type: 'break' },
      { time: '17:00–19:00', title: 'Chytrý kvíz', type: 'highlight' },
      { time: '19:00–20:00', title: 'Osobní volno', type: 'break' },
      { time: '20:00–24:00', title: 'Večeře a večerní párty', type: 'highlight' }
    ],
    day2: [
      { time: '08:00–08:45', title: 'Snídaně', type: 'break' },
      { time: '09:00–15:45', title: 'Přednáškové bloky BestDrive', type: 'main' },
      { time: '10:40–11:10', title: 'Coffee break', type: 'break' },
      { time: '12:00–13:00', title: 'Oběd', type: 'break' },
      { time: '15:45', title: 'Ukončení porady', type: 'main' }
    ]
  };

  return (
    <section className="py-24 px-6 bg-[#050505]">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-16 text-center">
          Harmonogram akce
        </h2>

        {/* Day 1 */}
        <div className="mb-16">
          <div className="flex items-center gap-4 mb-8">
            <div className="bg-[#FDB913] text-black px-6 py-2 rounded-full font-bold">DEN 1</div>
            <div className="flex-1 h-px bg-zinc-800" />
          </div>
          
          <div className="space-y-4">
            {timeline.day1.map((item, idx) => (
              <TimelineItem key={idx} item={item} />
            ))}
          </div>
        </div>

        {/* Day 2 */}
        <div>
          <div className="flex items-center gap-4 mb-8">
            <div className="bg-[#FDB913] text-black px-6 py-2 rounded-full font-bold">DEN 2</div>
            <div className="flex-1 h-px bg-zinc-800" />
          </div>
          
          <div className="space-y-4">
            {timeline.day2.map((item, idx) => (
              <TimelineItem key={idx} item={item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const TimelineItem = ({ item }) => {
  const typeColors = {
    main: 'border-zinc-700 bg-zinc-900',
    break: 'border-zinc-800 bg-zinc-950',
    highlight: 'border-[#FDB913] bg-[#FDB913]/5'
  };

  return (
    <div className={`border ${typeColors[item.type]} rounded-lg p-4 flex items-center gap-4 hover:border-[#FDB913] transition-colors`}>
      <div className="w-32 flex-shrink-0">
        <div className={`text-sm font-bold ${item.type === 'highlight' ? 'text-[#FDB913]' : 'text-zinc-400'}`}>
          {item.time}
        </div>
      </div>
      <div className="flex-1">
        <div className={`font-semibold ${item.type === 'highlight' ? 'text-[#FDB913]' : 'text-white'}`}>
          {item.title}
        </div>
      </div>
      {item.type === 'highlight' && (
        <Sparkles className="w-5 h-5 text-[#FDB913]" />
      )}
    </div>
  );
};

// Quiz Section
const QuizSection = () => (
  <section className="py-24 px-6 bg-[#121212] relative overflow-hidden">
    <div className="absolute inset-0 z-0 opacity-10">
      <img 
        src="https://images.pexels.com/photos/713149/pexels-photo-713149.jpeg?w=1920&q=85"
        alt="Quiz stage"
        className="w-full h-full object-cover"
      />
    </div>

    <div className="relative z-10 max-w-6xl mx-auto">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-3 bg-[#FDB913] text-black px-6 py-3 rounded-full mb-6 font-bold">
          <Trophy className="w-5 h-5" />
          <span className="tracking-tight">KONCEPT: CHYTRÝ KVÍZ</span>
        </div>
        <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-6">
          Interaktivní týmová soutěž
        </h2>
        <p className="text-zinc-400 text-lg max-w-3xl mx-auto">
          Game show formát s využitím mobilních aplikací, Click Play zařízení a živým promítáním výsledků.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Left: Format */}
        <div className="bg-zinc-900/80 backdrop-blur border border-zinc-800 rounded-xl p-8">
          <h3 className="text-xl font-bold mb-6 text-[#FDB913]">Formát soutěže</h3>
          <div className="space-y-4 text-zinc-300">
            <div>
              <div className="font-semibold text-white mb-1">Týmové složení</div>
              <p className="text-sm">140 osob rozděleno do týmů • živé výsledky • soutěžní atmosféra</p>
            </div>
            <div>
              <div className="font-semibold text-white mb-1">Technologie</div>
              <p className="text-sm">Mobilní aplikace + Click Play tlačítka • interaktivní ovládání</p>
            </div>
            <div>
              <div className="font-semibold text-white mb-1">Struktura</div>
              <p className="text-sm">Warm-up → hlavní kola → speciální výzvy → finále</p>
            </div>
          </div>
        </div>

        {/* Right: Content Categories */}
        <div className="bg-zinc-900/80 backdrop-blur border border-zinc-800 rounded-xl p-8">
          <h3 className="text-xl font-bold mb-6 text-[#FDB913]">Tematické okruhy</h3>
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-black/40 border border-zinc-700 rounded-lg p-3 text-center">
              <Car className="w-6 h-6 text-[#FDB913] mx-auto mb-2" />
              <div className="text-sm font-semibold">Automotive</div>
            </div>
            <div className="bg-black/40 border border-zinc-700 rounded-lg p-3 text-center">
              <Trophy className="w-6 h-6 text-[#FDB913] mx-auto mb-2" />
              <div className="text-sm font-semibold">Business</div>
            </div>
            <div className="bg-black/40 border border-zinc-700 rounded-lg p-3 text-center">
              <Camera className="w-6 h-6 text-[#FDB913] mx-auto mb-2" />
              <div className="text-sm font-semibold">Filmy / Sport</div>
            </div>
            <div className="bg-black/40 border border-zinc-700 rounded-lg p-3 text-center">
              <Sparkles className="w-6 h-6 text-[#FDB913] mx-auto mb-2" />
              <div className="text-sm font-semibold">IQ / Postřeh</div>
            </div>
          </div>

          <div className="mt-6 pt-6 border-t border-zinc-800">
            <h4 className="text-sm font-bold text-zinc-400 mb-3">Speciální kola</h4>
            <ul className="text-sm text-zinc-400 space-y-1">
              <li>• Risk otázky</li>
              <li>• Tipovací otázky</li>
              <li>• Audio/video kola</li>
              <li>• Live challenge na pódiu</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Finale Info */}
      <div className="mt-8 bg-[#FDB913]/10 border border-[#FDB913] rounded-xl p-6 text-center">
        <p className="text-zinc-300">
          <span className="font-bold text-[#FDB913]">Finále:</span> Top týmy postupují do závěrečného kola • Vyhlášení vítězů během večerní party
        </p>
      </div>
    </div>
  </section>
);

// Party Section
const PartySection = () => (
  <section className="py-24 px-6 bg-[#050505] relative overflow-hidden">
    <div className="absolute inset-0 z-0 opacity-10">
      <img 
        src="https://images.pexels.com/photos/35042459/pexels-photo-35042459.jpeg?w=1920&q=85"
        alt="Party event"
        className="w-full h-full object-cover"
      />
    </div>

    <div className="relative z-10 max-w-6xl mx-auto">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-3 bg-[#FDB913] text-black px-6 py-3 rounded-full mb-6 font-bold">
          <Music className="w-5 h-5" />
          <span className="tracking-tight">KONCEPT: VEČERNÍ PÁRTY</span>
        </div>
        <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight">
          Networking & Entertainment
        </h2>
      </div>

      <div className="bg-zinc-900/80 backdrop-blur border border-zinc-800 rounded-xl p-8 max-w-4xl mx-auto mb-12">
        <div className="space-y-4">
          {/* Timeline Items */}
          <div className="flex gap-4 items-start py-3 border-b border-zinc-800">
            <div className="text-[#FDB913] font-bold min-w-[140px] text-sm">20:00 – 24:00</div>
            <div className="flex-1">
              <div className="font-semibold text-white">DJ a moderátor</div>
              <div className="text-sm text-zinc-400">Po celou dobu akce</div>
            </div>
          </div>
          
          <div className="flex gap-4 items-start py-3 border-b border-zinc-800">
            <div className="text-[#FDB913] font-bold min-w-[140px] text-sm">20:00 – 20:30</div>
            <div className="flex-1">
              <div className="font-semibold text-white">Zahájení večírku a vyhodnocení chytrého kvízu</div>
            </div>
          </div>
          
          <div className="flex gap-4 items-start py-3 border-b border-zinc-800">
            <div className="text-[#FDB913] font-bold min-w-[140px] text-sm">20:30 – 24:00</div>
            <div className="flex-1">
              <div className="font-semibold text-white">Kapela Party Leaders</div>
              <div className="text-sm text-zinc-400">Živá hudba, tanec, zábava</div>
            </div>
          </div>
          
          <div className="flex gap-4 items-start py-3 border-b border-zinc-800">
            <div className="text-[#FDB913] font-bold min-w-[140px] text-sm">21:15 – 21:35</div>
            <div className="flex-1">
              <div className="font-semibold text-white">Stage show iluzionisty Obinn Magic</div>
              <div className="text-sm text-zinc-400">Pódium, efekty, divácká show</div>
            </div>
          </div>
          
          <div className="flex gap-4 items-start py-3 border-b border-zinc-800">
            <div className="text-[#FDB913] font-bold min-w-[140px] text-sm">21:45 – 23:15</div>
            <div className="flex-1">
              <div className="font-semibold text-white">Iluzionista Obinn Magic mezi hosty</div>
              <div className="text-sm text-zinc-400">Close-up magie, interakce s účastníky</div>
            </div>
          </div>
          
          <div className="flex gap-4 items-start py-3 border-b border-zinc-800">
            <div className="text-[#FDB913] font-bold min-w-[140px] text-sm">20:30 – 23:30</div>
            <div className="flex-1">
              <div className="font-semibold text-white">Mobilní kasino</div>
              <div className="text-sm text-zinc-400">Ruleta, blackjack, poker</div>
            </div>
          </div>
          
          <div className="flex gap-4 items-start py-3 border-b border-zinc-800">
            <div className="text-[#FDB913] font-bold min-w-[140px] text-sm">23:30 – 23:45</div>
            <div className="flex-1">
              <div className="font-semibold text-white">Dražba kasina o ceny</div>
              <div className="text-sm text-zinc-400">Vyhodnocení výher a ocenění</div>
            </div>
          </div>
          
          <div className="flex gap-4 items-start py-3">
            <div className="text-[#FDB913] font-bold min-w-[140px] text-sm">20:30 – 23:30</div>
            <div className="flex-1">
              <div className="font-semibold text-white">Fotokoutek /vizuál akce/</div>
              <div className="text-sm text-zinc-400">Branding BestDrive, okamžité fotky</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Benefits */}
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-zinc-900/60 border border-zinc-800 rounded-xl p-6 text-center">
          <Award className="w-8 h-8 text-[#FDB913] mx-auto mb-3" />
          <h4 className="font-bold mb-2">Silný networking</h4>
          <p className="text-sm text-zinc-400">4 hodiny neformální interakce</p>
        </div>
        <div className="bg-zinc-900/60 border border-zinc-800 rounded-xl p-6 text-center">
          <Sparkles className="w-8 h-8 text-[#FDB913] mx-auto mb-3" />
          <h4 className="font-bold mb-2">Zážitková složka</h4>
          <p className="text-sm text-zinc-400">Kasino, magie, živá hudba</p>
        </div>
        <div className="bg-zinc-900/60 border border-zinc-800 rounded-xl p-6 text-center">
          <Camera className="w-8 h-8 text-[#FDB913] mx-auto mb-3" />
          <h4 className="font-bold mb-2">Fotodokumentace</h4>
          <p className="text-sm text-zinc-400">Fotokoutek s branding BestDrive</p>
        </div>
      </div>
    </div>
  </section>
);

// Technical Section
const TechnicalSection = () => (
  <section className="py-24 px-6 bg-[#121212]">
    <div className="max-w-5xl mx-auto">
      <h2 className="font-['Exo_2'] text-4xl font-bold tracking-tight mb-12 text-center">
        Technické zajištění
      </h2>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6">
          <Monitor className="w-8 h-8 text-[#FDB913] mb-4" />
          <h3 className="text-lg font-bold mb-3">Hlavní sál</h3>
          <p className="text-zinc-400 text-sm">Kapacita 140 osob • Projekce • Ozvučení • Mikrofony • Pódiové osvětlení</p>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6">
          <Hotel className="w-8 h-8 text-[#FDB913] mb-4" />
          <h3 className="text-lg font-bold mb-3">Breakout místnosti</h3>
          <p className="text-zinc-400 text-sm">5–6 prostorů • Flipcharty • AV technika • Wifi</p>
        </div>

        <div className="col-span-full bg-zinc-900 border border-zinc-800 rounded-xl p-6">
          <Wifi className="w-8 h-8 text-[#FDB913] mb-4" />
          <h3 className="text-lg font-bold mb-3">Kompletní AV support</h3>
          <p className="text-zinc-400 text-sm">
            Technik na místě po celou dobu • Prezentační podpora • Live stream možnosti • Záložní technika
          </p>
        </div>
      </div>
    </div>
  </section>
);

// Pricing Section
const PricingSection = ({ programCosts, programTotal, selectedHotel, partyItems, selectedPartyItems, togglePartyItem, exportToPDF }) => {
  const grandTotal = selectedHotel ? selectedHotel.price + programTotal : null;
  
  return (
    <section id="pricing-section" className="py-24 px-6 bg-[#050505]">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-['Exo_2'] text-4xl font-bold tracking-tight mb-12 text-center">
          Cenová kalkulace
        </h2>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8">
          
          {/* Selected Hotel Section */}
          {selectedHotel ? (
            <div className="mb-8 pb-8 border-b border-zinc-700">
              <div className="flex items-center gap-3 mb-6">
                <CheckCircle2 className="w-6 h-6 text-[#FDB913]" />
                <h3 className="text-lg font-bold text-[#FDB913]">Vybraná varianta hotelu</h3>
              </div>
              
              <div className="bg-black/40 border border-zinc-700 rounded-lg p-6 mb-4">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h4 className="text-xl font-bold mb-1">{selectedHotel.name}</h4>
                    <p className="text-sm text-zinc-400">{selectedHotel.location}</p>
                  </div>
                  <img 
                    src={selectedHotel.image} 
                    alt={selectedHotel.name}
                    className="w-20 h-14 rounded-lg object-cover"
                  />
                </div>
                
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-zinc-400">Ubytování (20× single + 60× twin)</span>
                    <span className="font-semibold">{selectedHotel.priceBreakdown.ubytovani.toLocaleString('cs-CZ')} Kč</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-zinc-400">Pronájem prostorů (sál C + D + 4 salónky)</span>
                    <span className="font-semibold">{selectedHotel.priceBreakdown.pronajem.toLocaleString('cs-CZ')} Kč</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-zinc-400">Strava (2× oběd, 3× coffee break, večeře)</span>
                    <span className="font-semibold">{selectedHotel.priceBreakdown.strava.toLocaleString('cs-CZ')} Kč</span>
                  </div>
                  {selectedHotel.priceBreakdown.prestavba && (
                    <div className="flex justify-between">
                      <span className="text-zinc-400">Přestavba sálu (večerní část)</span>
                      <span className="font-semibold">{selectedHotel.priceBreakdown.prestavba.toLocaleString('cs-CZ')} Kč</span>
                    </div>
                  )}
                  {selectedHotel.priceBreakdown.parking && (
                    <div className="flex justify-between">
                      <span className="text-zinc-400">Parkování (50 vozidel)</span>
                      <span className="font-semibold">{selectedHotel.priceBreakdown.parking.toLocaleString('cs-CZ')} Kč</span>
                    </div>
                  )}
                  <div className="border-t border-zinc-700 pt-2 mt-2 flex justify-between font-bold">
                    <span>Celkem hotel</span>
                    <span className="text-[#FDB913]">{selectedHotel.price.toLocaleString('cs-CZ')} Kč</span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="mb-8 pb-8 border-b border-zinc-700">
              <div className="bg-zinc-800/50 border border-zinc-700 rounded-lg p-8 text-center">
                <Hotel className="w-12 h-12 text-zinc-600 mx-auto mb-4" />
                <p className="text-zinc-400 text-lg mb-2">Nebyla vybrána žádná varianta hotelu</p>
                <p className="text-zinc-500 text-sm">Vyberte jeden z hotelů výše pro zobrazení kompletní kalkulace</p>
              </div>
            </div>
          )}
          
          {/* Program Costs */}
          <div className="mb-8">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-bold text-[#FDB913]">Společné náklady programu</h3>
              <p className="text-sm text-zinc-400">Upravte položky dle vašich potřeb</p>
            </div>
            
            {/* Evening Party - Interactive with Checkboxes */}
            <div className="bg-zinc-800/50 border border-zinc-700 rounded-lg p-6 mb-4">
              <div className="flex justify-between items-center mb-4">
                <h4 className="font-bold text-white">Večerní část (volitelné položky)</h4>
                <span className="font-bold text-[#FDB913]">{programCosts.vecerniParty.toLocaleString('cs-CZ')} Kč</span>
              </div>
              
              <div className="space-y-3">
                {partyItems.map((item) => (
                  <label 
                    key={item.id}
                    className="flex items-center justify-between p-3 bg-black/40 rounded-lg cursor-pointer hover:bg-black/60 transition-colors"
                  >
                    <div className="flex items-center gap-3 flex-1">
                      <input
                        type="checkbox"
                        checked={selectedPartyItems[item.id]}
                        onChange={() => togglePartyItem(item.id)}
                        className="w-5 h-5 rounded border-zinc-600 text-[#FDB913] focus:ring-[#FDB913] focus:ring-offset-0 cursor-pointer"
                      />
                      <span className={`text-sm ${selectedPartyItems[item.id] ? 'text-white' : 'text-zinc-500 line-through'}`}>
                        {item.name}
                      </span>
                    </div>
                    <span className={`text-sm font-semibold ${selectedPartyItems[item.id] ? 'text-zinc-300' : 'text-zinc-600'}`}>
                      {item.price.toLocaleString('cs-CZ')} Kč
                    </span>
                  </label>
                ))}
              </div>
            </div>
            
            {/* Fixed Program Costs */}
            <div className="space-y-3">
              <div className="flex justify-between items-center py-3 bg-zinc-800/30 rounded-lg px-4">
                <span className="text-zinc-300">Agenturní provize</span>
                <span className="font-bold">{programCosts.agenturniProvize.toLocaleString('cs-CZ')} Kč</span>
              </div>
              <div className="flex justify-between items-center py-3 bg-zinc-800/30 rounded-lg px-4">
                <span className="text-zinc-300">Produkce a koordinace akce</span>
                <span className="font-bold">{programCosts.produkce.toLocaleString('cs-CZ')} Kč</span>
              </div>
              <div className="flex justify-between items-center py-3 bg-[#FDB913]/10 rounded-lg px-4 mt-4">
                <span className="font-bold text-[#FDB913]">Celkem program</span>
                <span className="font-bold text-[#FDB913] text-xl">{programTotal.toLocaleString('cs-CZ')} Kč</span>
              </div>
            </div>
          </div>

          {/* Grand Total */}
          {selectedHotel && (
            <>
              <div className="bg-gradient-to-r from-[#FDB913]/20 to-[#FDB913]/10 border-2 border-[#FDB913] rounded-xl p-6">
                <div className="flex justify-between items-center">
                  <div>
                    <div className="text-sm text-zinc-300 mb-1">Celková investice</div>
                    <div className="text-xl font-bold text-white">
                      {selectedHotel.name} + Program
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-4xl font-bold text-[#FDB913]">
                      {grandTotal.toLocaleString('cs-CZ')} Kč
                    </div>
                    <div className="text-sm text-zinc-400">bez DPH</div>
                  </div>
                </div>
              </div>
              
              {/* Export PDF Button */}
              <button
                onClick={exportToPDF}
                className="w-full mt-4 py-4 rounded-lg font-bold text-lg transition-all flex items-center justify-center gap-3 bg-[#FDB913] text-black hover:bg-[#FDB913]/90 shadow-lg hover:shadow-[#FDB913]/30"
              >
                <Download className="w-5 h-5" />
                Stáhnout nabídku jako PDF
              </button>
            </>
          )}

          <div className="bg-black/40 border border-zinc-700 rounded-lg p-6 mt-6">
            <h4 className="text-sm font-bold text-zinc-400 mb-4">Podmínky</h4>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li>• Maximální rozpočet: <span className="text-white font-semibold">950 000 Kč bez DPH</span></li>
              <li>• Náklady hotelu + program jsou odděleny pro přehlednost</li>
              <li>• Fakturace: 90 % CZ / 10 % SK (dle lokality účastníků)</li>
              <li>• Uvedené ceny jsou bez DPH</li>
              <li>• Večerní program lze flexibilně upravit dle rozpočtu</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

// CTA Section
const CTASection = () => (
  <section className="py-24 px-6 bg-[#121212]">
    <div className="max-w-4xl mx-auto text-center">
      <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-6">
        Další kroky
      </h2>
      <p className="text-zinc-400 text-lg mb-12 max-w-2xl mx-auto">
        Stáhněte si .pdf nabídku dle vaší volby a uložte ji pro další využití. Kontaktujte nás pro případné upřesňující dotazy, nebo doladění nabídky.
      </p>

      {/* Contact Info */}
      <div className="mt-16 grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <Phone className="w-8 h-8 text-[#FDB913] mx-auto mb-3" />
          <div className="text-sm text-zinc-400 mb-1">Telefon</div>
          <a href="tel:+420773550880" className="text-white hover:text-[#FDB913] font-semibold transition-colors">
            +420 773 550 880
          </a>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <Mail className="w-8 h-8 text-[#FDB913] mx-auto mb-3" />
          <div className="text-sm text-zinc-400 mb-1">Email</div>
          <a href="mailto:info@vseproakci.cz" className="text-white hover:text-[#FDB913] font-semibold transition-colors">
            info@vseproakci.cz
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default BestDriveOfferPage;
